
window.transferLan = async (local) => {
    try {
        const {data: res} = await axios.get( '/language/switch/' + local);
        $toast('language changed successfully.', 'success');
        window.location.reload();
    }catch (e) {
        console.log('error', e);
    }
};

const scrollToTop = () => {
    window.scrollTo({ behavior: 'smooth', top:0 });
};

window.clientLogout = async () => {
    try{
        const {data} = await axios.get('/client-logout');
        scrollToTop();
        if (data.status) {
            $toast(data.message, data.type);
            redirect(data.redirect_to, 1000)
        } else {
            $toast(data.error ?? data.message, data.type ?? 'error');
        }
    } catch (error) {
        console.error('Logout error', error);
        const message = error.response?.data?.message ?? 'An unexpected error occurred.';
        $toast(error.response?.status === 422 ? 'Please fix validation errors.' : message, 'error');
    }
}

window.studentLogout = async () => {
    try{
        const {data} = await axios.get('/student-logout');
        scrollToTop();
        if (data.status) {
            $toast(data.message, data.type);
            redirect(data.redirect_to, 1000)
        } else {
            $toast(data.error ?? data.message, data.type ?? 'error');
        }
    } catch (error) {
        console.error('Logout error', error);
        const message = error.response?.data?.message ?? 'An unexpected error occurred.';
        $toast(error.response?.status === 422 ? 'Please fix validation errors.' : message, 'error');
    }
}


const toggleButtonStatus = (submitButton, loadingButton, isLoading) => {
    if (loadingButton) {
        loadingButton.classList.toggle('d-none', !isLoading);
    }
    if (submitButton) {
        submitButton.classList.toggle('d-none', isLoading);
        submitButton.disabled = isLoading;
    }
};

const clearFormErrors = (form) => {
    form.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
    form.querySelectorAll('.invalid-feedback').forEach((el) => {
        el.style.display = 'none';
        el.textContent = '';
    });
    form.querySelectorAll('p.error').forEach((el) => (el.textContent = ''));
};

const closeModal = (modal, modalInput) => {
    if (modal && modalInput?.value) {
        modal.classList.remove('show');
        modal.style.display = 'none';
        document.body.classList.remove('modal-open');
        document.querySelector('.modal-backdrop')?.remove();
    }
}

const redirect = (url, delay = 0) => {
    if (url) {
        setTimeout(() =>{
            window.location.href = url
        }, delay);
    } else {
        setTimeout(() =>{
            window.location.reload();
        }, delay);
    }
};

const showContactSuccessAlert = async () => {
    if (typeof Swal === 'undefined') {
        return;
    }

    await Swal.fire({
        title: '<span style="color:#047857;font-weight:700;">Thank You</span>',
        html: `
            <div style="text-align:center;padding:8px 4px 2px;">
                <p style="font-size:1.05rem;line-height:1.6;font-weight:600;color:#1f2937;margin:0 0 14px;">
                    Your message has been submitted successfully.
                </p>

                <div style="margin:14px 0;padding:16px;background:#ecfdf5;border:1px solid #a7f3d0;border-radius:10px;">
                    <div style="width:42px;height:42px;line-height:42px;margin:0 auto 10px;border-radius:50%;background:#059669;color:#ffffff;font-size:22px;font-weight:700;">
                        &#10003;
                    </div>
                    <p style="color:#047857;font-size:1rem;font-weight:700;margin:0 0 7px;">
                        Message Received
                    </p>
                    <p style="color:#065f46;font-size:0.93rem;line-height:1.55;margin:0;">
                        Our team has received your message and will review it carefully. We will contact you shortly if a response is required.
                    </p>
                </div>

                <p style="font-size:0.9rem;line-height:1.5;color:#6b7280;margin:12px 0 0;">
                    Thank you for contacting us.
                </p>
            </div>
        `,
        icon: 'success',
        confirmButtonColor: '#059669',
        confirmButtonText: 'OK, Got It',
        allowOutsideClick: true,
        allowEscapeKey: true,
        customClass: {
            popup: 'contact-success-alert'
        }
    });
};

const handleValidationErrors = (form, errors) => {
    const resolveInput = (fieldKey) => {
        const exactInput = form.querySelector(`[name="${fieldKey}"]`);
        if (exactInput) {
            return exactInput;
        }

        const normalizedKey = fieldKey.replace(/\.(\d+)/g, '[$1]').replace(/\.(\w+)/g, '[$1]');
        const normalizedInput = form.querySelector(`[name="${normalizedKey}"]`);
        if (normalizedInput) {
            return normalizedInput;
        }

        const fileArrayKey = normalizedKey.replace(/\[\d+\]$/, '[]');
        return form.querySelector(`[name="${fileArrayKey}"]`);
    };

    Object.entries(errors || {}).forEach(([key, value]) => {
        const input = resolveInput(key);
        if (!input) return;

        const errorId = input.id ?? input.name;
        const errorContainer = document.getElementById(`error-${errorId}`);
        if (!errorContainer) return;
        input.classList.add('is-invalid');
        errorContainer.textContent = value[0];
        errorContainer.style.display = 'block';

    });
};

const confirmSubmission = (confirmBtnText, summery) => {
    const btnText = confirmBtnText ?? 'Yes!';
    const bodyText = summery ?? "You won't be able to revert this!";

    return Swal.fire({
        title: 'Are you sure?',
        text: bodyText,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#007bff',
        cancelButtonColor: '#d33',
        confirmButtonText: btnText,
    });
};

window.deleteItem = (deleteUrl) => {
    confirmSubmission('Yes, Delete it!', "You won't be able to revert this!").then(async (result) => {
        if (!result.isConfirmed) return;

        try {
            if (!deleteUrl) {
                $toast('Delete URL is missing.', 'error');
                return;
            }

            const {data: res} = await axios.delete(deleteUrl);
            $toast(res.message, res.flash_type);
            redirect(res.redirect_to, res.delay);
        } catch (error) {
            const errMsg = error.response?.data?.message ?? error.message ?? 'An unexpected error occurred during delete.';
            $toast(errMsg, 'error');
            console.error('delete error =>', error);
        }
    });
};

const confirmDeleteSubmission = async (form) => {
    if (form.dataset.confirmed === 'true') {
        return true;
    }

    if (typeof Swal === 'undefined') {
        return true;
    }

    const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0d6efd',
        cancelButtonColor: '#dc3545',
        confirmButtonText: 'Yes, Delete it!'
    });

    if (!result.isConfirmed) {
        return false;
    }

    form.dataset.confirmed = 'true';
    form.requestSubmit ? form.requestSubmit() : form.submit();
    return false;
};

document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!form.matches('form[data-confirm-delete="true"]')) {
        return;
    }

    const shouldContinue = await confirmDeleteSubmission(form);

    if (!shouldContinue) {
        event.preventDefault();
    }
}, true);


// Website AXIOS form handler
const handleFormSubmit = async (event) => {
    const form = event.target;
    if (!form.classList.contains('web_axios_form')) return;
    event.preventDefault();
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const loadingButton = form.querySelector('.preloader_button');
    const modalInput = form.querySelector('.is_modal');
    const modal = form.closest('.modal');
    const action = form.getAttribute('action');
    const method = form.getAttribute('method')?.toUpperCase() ?? 'POST';
    const isJson = form.dataset.contentType === 'json'; // Add data-content-type="json" to form for JSON payload
    const shouldSkipRedirect = form.dataset.skipRedirect === 'true';
    const data = isJson ? Object.fromEntries(new FormData(form)) : new FormData(form);

    try {
        toggleButtonStatus(submitButton, loadingButton, true);
        clearFormErrors(form);
        const {data: response} = await axios({
            url: action,
            method,
            data,
        })

        scrollToTop();

        const type = response.type &&  response.flash_type === '' ? response.type : response.flash_type;

        if (response.status) {
            $toast(response.success ?? response.message, type);
            form.reset();
            if (form.dataset.successAlert === 'contact') {
                toggleButtonStatus(submitButton, loadingButton, false);
                await showContactSuccessAlert();
            }
            closeModal(modal, modalInput);
            if (!shouldSkipRedirect) {
                redirect(response.route ?? response.redirect_to, response.delay);
            }
        } else {
            $toast(response.error ?? response.message, 'error')
        }

    } catch(error) {
        console.error('Form submission error:', error);
        if (error.response?.status === 422) {
            handleValidationErrors(form, error.response.data.errors)
            $toast(error.response.data?.message ?? 'Please fix validation errors.', 'error')
        } else {
            $toast(error.response?.data?.message ?? 'An unexpected error occurred.', 'error');
        }
    } finally {
        toggleButtonStatus(submitButton, loadingButton, false);
    }
}

document.addEventListener('submit', handleFormSubmit);
